import get from 'lodash/get';
import PaymentConstants from './PaymentConstants';

export const normalizeCardType = (cardType = '') =>
    cardType
        .toString()
        .toLowerCase()
        .replace(/[\s_-]/g, '');

export const getMarketplaceRestrictedCardTypes = (context = {}) => {
    const configuredCardTypes = get(context, 'preferences.marketplaceRestrictedCardTypes');

    return Array.isArray(configuredCardTypes)
        ? configuredCardTypes
        : PaymentConstants.MARKETPLACE_RESTRICTED_CARD_TYPES;
};

export const isMarketplaceRestrictedCardType = (cardType, context = {}) =>
    getMarketplaceRestrictedCardTypes(context)
        .map((restrictedCardType) =>
            normalizeCardType(
                get(restrictedCardType, 'name', get(restrictedCardType, 'type', restrictedCardType))
            )
        )
        .indexOf(normalizeCardType(cardType)) > -1;

export const isMarketplaceRestrictedCardEntry = (newPayment = {}, context = {}) => {
    const hasMarketplaceItemsInCart = get(newPayment, 'hasMarketplaceItemsInCart', false);
    const cardInfo = get(newPayment, 'creditCardUserInputInfo.cardInfo', {});
    /**
     * Restricts Guest/Registered Add new card & Guest edit payment
     * !showEditCreditCardForm indicates Registered user edit card excluded
     */
    const showNewCreditCardForm = get(newPayment, 'showNewCreditCardForm', false);
    const showEditCreditCardForm = get(newPayment, 'showEditCreditCardForm', false);
    const isAddNewCardEntry = showNewCreditCardForm && !cardInfo.id;
    const isGuestEditCardEntry = showNewCreditCardForm && !!cardInfo.id && !showEditCreditCardForm;
    const isRestrictedCard =
        cardInfo.isMarketplaceRestrictedCard ||
        isMarketplaceRestrictedCardType(cardInfo.type, context);

    return !!(
        hasMarketplaceItemsInCart &&
        cardInfo.isNumberEditable &&
        isRestrictedCard &&
        (isAddNewCardEntry || isGuestEditCardEntry)
    );
};
